import Vue from "vue";
class WorkOrderService {
  SearchTrees(filter, page) {
    return Vue.prototype.$http({
      url: "/work-order/search-trees/" + page + "/20",
      data: filter,
      method: "POST"
    });
  }

  GetGrid(page, filter) {
    let query = [];
    if (filter) {
      if (filter.status) query.push("status=" + filter.status);
      if (filter.teamId) query.push("teamId=" + filter.teamId);
      if (filter.projectId) query.push("projectId=" + filter.projectId);
    }

    return Vue.prototype.$http({
      url:
        "/work-order/get-grid/" +
        page +
        "/20" +
        (query.length > 0 ? "?" + query.join("&") : ""),
      method: "GET"
    });
  }

  Get(id) {
    return Vue.prototype.$http({
      url: "/work-order/get/" + id,
      method: "GET"
    });
  }

  New(viewModel) {
    return Vue.prototype.$http({
      url: "/work-order/new",
      data: viewModel,
      method: "POST"
    });
  }

  Edit(viewModel) {
    return Vue.prototype.$http({
      url: "/work-order/edit",
      data: viewModel,
      method: "PUT"
    });
  }

  ChangeStatus(id, status) {
    return Vue.prototype.$http({
      url: "/work-order/change-status",
      data: { id: id, status: status },
      method: "PUT"
    });
  }

  Remove(id) {
    return Vue.prototype.$http({
      url: "/work-order/remove/" + id,
      method: "DELETE"
    });
  }

  ExecuteItem(viewModel) {
    return Vue.prototype.$http({
      url: "/work-order/item/execute",
      data: viewModel,
      method: "PUT"
    });
  }

  AddItemFiles(workOrderItemId, files) {
    return Vue.prototype.$http({
      url: "/work-order/item/files",
      data: { workOrderItemId: workOrderItemId, files: files },
      method: "POST"
    });
  }

  GetItemFiles(workOrderItemId) {
    return Vue.prototype.$http({
      url: "/work-order/item/get-files?workOrderItemId=" + workOrderItemId,
      method: "GET"
    });
  }

  RemoveItemFile(id, workOrderItemId) {
    return Vue.prototype.$http({
      url:
        "/work-order/item/remove-file?id=" +
        id +
        "&workOrderItemId=" +
        workOrderItemId,
      method: "DELETE"
    });
  }
}

export default new WorkOrderService();
